<script setup lang="ts">
const t2 = useT2({
  'Please sign in': 'Prašome prisijungti',
})

const props = defineProps<{
  onAuth?: () => void
}>()

const state = useAuthModal()
const auth = useAuth()

useUiPreview4({
  open: () => state.open.value,
})

const needsAuth = computed(() => !auth.value.isAuth)

watch(
  () => auth.value.isAuth,
  (auth, prev) => {
    if (prev === false && auth === true) props.onAuth?.()
    if (auth === false) state.set(true)
  },
  { immediate: true }
)
</script>

<template>
  <button v-if="needsAuth" type="button" :class="$style.cont" @click="state.set(true)">
    <span class="_h4 _row _gap1 _ctrY _gap1"><IconProfile class="_svg12" />{{ t2('Please sign in') }}</span>
  </button>
</template>

<style module>
.cont {
  composes: global(_br14);
  composes: global(_h50);
  composes: global(_mt1);
  composes: global(_mb1);
  composes: global(_ml1);
  composes: global(_mr1);
  composes: global(_flexblock);

  composes: global(_ctry);
  composes: global(_pl1);
  composes: global(_wmin100);

  max-width: calc(100% - 20px);
  border: 1px solid var(--blue7);
  box-shadow: 0 0 0 2px var(--blue8);
  width: 400px;
}
</style>
